// CopyShareButtons.jsx
import React, { useState } from 'react';
import copyImg from "../static_files/copy-selector.svg";
import copyHoverImg from "../static_files/copy-selector-hover.svg";
import copyConfirmImg from "../static_files/copyConfirmMobile.png";
import shareImg from "../static_files/share-selector.svg";
import shareHoverImg from "../static_files/share-selector-hover.svg";

const CopyShareButtons = ({ textToCopy, urlToOpen, containerStyle }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = (e) => {
        const imgElement = e.currentTarget;
        imgElement.setAttribute("data-copied", "true");

        navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                setIsCopied(true);
                imgElement.src = copyConfirmImg;
                imgElement.style.width = "10px";
                imgElement.style.height = "10px";

                setTimeout(() => {
                    imgElement.src = copyImg;
                    imgElement.removeAttribute("data-copied");
                    setIsCopied(false);
                }, 3000);
            })
            .catch((err) => console.error("Copy failed:", err));
    };

    const handleShare = () => {
        window.open(urlToOpen, "_blank");
    };

    return (
        <div style={{ display: 'flex', ...containerStyle }}>
            <img
                style={{
                    width: "9.49px",
                    height: "11.88px",
                    marginRight: '6px',
                    cursor: 'pointer'
                }}
                src={copyImg}
                alt="copy"
                onMouseEnter={(e) => {
                    if (!isCopied) {
                        e.currentTarget.src = copyHoverImg;
                    }
                }}
                onMouseLeave={(e) => {
                    if (!e.currentTarget.getAttribute("data-copied") && !isCopied) {
                        e.currentTarget.src = copyImg;
                    }
                }}
                onClick={handleCopy}
            />
            <img
                style={{
                    width: "11px",
                    height: "11px",
                    cursor: 'pointer'
                }}
                src={shareImg}
                alt="share"
                onMouseEnter={(e) => {
                    e.currentTarget.src = shareHoverImg;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.src = shareImg;
                }}
                onClick={handleShare}
            />
        </div>
    );
};

export default CopyShareButtons;